// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Ozo9","buttons":"Footer_buttons__4FeQH"};